import ServiceCategoryPage from '@/components/business/ServiceCategoryPage';
import { makeServiceCategoryPaths, makeServiceCategoryProps } from '@/lib/serviceCategoryFactory';
import { BusinessItem } from '@/core/models/businesses/businessList';
import { GetStaticPaths, GetStaticProps } from 'next';

const CATEGORY_ID = '1751';
const CATEGORY_LABEL = 'Vehicle License';
const CATEGORY_SLUG = 'vehicle-license';
const CATEGORY_DESCRIPTION = 'Find vehicle licensing services and assistance near you. Get help with motor vehicle licence applications and renewals.';
const TAGS: string[] = ['Licence Disc', 'Motor Vehicle Licence', 'Roadworthy', 'Traffic Department'];

interface Props {
    businesses: BusinessItem[];
    pagination: { count: number; currentPage: number; totalPages: number };
    city: string;
    cityName: string;
}

export default function VehicleLicenseCityPage({ businesses, pagination, city, cityName }: Props) {
    return (
        <ServiceCategoryPage
            businesses={businesses}
            pagination={pagination}
            city={city}
            cityName={cityName}
            categoryId={CATEGORY_ID}
            categoryLabel={CATEGORY_LABEL}
            categorySlug={CATEGORY_SLUG}
            categoryDescription={CATEGORY_DESCRIPTION}
            tags={TAGS}
        />
    );
}

export const getStaticPaths: GetStaticPaths = makeServiceCategoryPaths();
export const getStaticProps: GetStaticProps = makeServiceCategoryProps(CATEGORY_ID);
